/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S6_Li5Inputs */

const en_guide_json_syntax_errors_s6_li5 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensure all values are valid JSON types (no <code>undefined</code>, <code>NaN</code>, or functions)`)
};

const ko_guide_json_syntax_errors_s6_li5 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 값이 유효한 JSON 타입인지 확인하세요(<code>undefined</code>, <code>NaN</code>, 함수 제외)`)
};

const ja_guide_json_syntax_errors_s6_li5 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての値が有効なJSON型であることを確認してください（<code>undefined</code>、<code>NaN</code>、関数は不可）`)
};

/**
* | output |
* | --- |
* | "Ensure all values are valid JSON types (no <code>undefined</code>, <code>NaN</code>, or functions)" |
*
* @param {Guide_Json_Syntax_Errors_S6_Li5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s6_li5 = /** @type {((inputs?: Guide_Json_Syntax_Errors_S6_Li5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S6_Li5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s6_li5(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s6_li5(inputs)
	return ja_guide_json_syntax_errors_s6_li5(inputs)
});